import { useEffect } from 'react';
import { TileCard } from '@empowernow/ui';
import { invalidateCapabilityProjection } from '../core/auth/capabilityProjection';
import { invalidateSessionCache } from '../core/session/SessionSingleFlight';

function safeReturnTo(raw: string | null): string {
  if (!raw) return '/';
  if (raw.startsWith('/') && !raw.startsWith('//')) return raw;
  return '/';
}

export default function AuthCallback() {
  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams(window.location.search);
    const returnTo = safeReturnTo(params.get('return_to'));

    (async () => {
      const started = Date.now();
      let authed = false;
      while (!cancelled && Date.now() - started < 30000 && !authed) {
        try {
          const r = await fetch('/auth/session', { credentials: 'include' });
          if (r.ok) {
            const j = await r.json().catch(() => ({}));
            if ((j as any)?.authenticated) {
              // Fresh login must not reuse a pre-grant capability projection.
              invalidateSessionCache();
              invalidateCapabilityProjection();
              authed = true;
              break;
            }
          }
        } catch { /* ignore */ }
        await new Promise(res => setTimeout(res, 500));
      }
      // Always navigate away to break potential loops
      window.location.replace(returnTo);
    })();

    return () => { cancelled = true; };
  }, []);

  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <TileCard theme="auto" elevation={2}>
        <div role="status" aria-live="polite" style={{ padding: 24, minWidth: 280, textAlign: 'center' }}>
          <div style={{ opacity: 0.85 }}>Completing sign-in…</div>
        </div>
      </TileCard>
    </div>
  );
}


